(() => {
  'use strict';
  if (window.__ibLayoutV58) return;
  window.__ibLayoutV58 = true;

  let headerElement;
  let headerGroup;
  let resizeObserver;
  let measureFrame = 0;
  let lastHeaderHeight = -1;
  let lastGroupHeight = -1;
  let lastTopRowHeight = -1;

  const writeMeasurement = (name, value, previous) => {
    if (value === previous) return previous;
    document.body.style.setProperty(name, `${value}px`);
    return value;
  };

  const measureHeader = () => {
    measureFrame = 0;
    if (!headerElement?.isConnected || !headerGroup?.isConnected) return;
    const topRow = headerElement.querySelector('.header__row--top');
    const headerHeight = headerElement.offsetHeight;
    const groupHeight = headerGroup.offsetHeight;
    const topRowHeight = topRow?.offsetHeight || 0;

    lastHeaderHeight = writeMeasurement('--header-height', headerHeight, lastHeaderHeight);
    lastGroupHeight = writeMeasurement('--header-group-height', groupHeight, lastGroupHeight);
    if (topRow) lastTopRowHeight = writeMeasurement('--top-row-height', topRowHeight, lastTopRowHeight);
    else if (lastTopRowHeight !== 0) {
      document.body.style.removeProperty('--top-row-height');
      lastTopRowHeight = 0;
    }
  };

  const scheduleMeasurement = () => {
    if (!measureFrame) measureFrame = requestAnimationFrame(measureHeader);
  };

  const updateMenuStyle = () => {
    const header = document.querySelector('#header-component') || headerElement;
    if (!header) return;
    const isTouchDevice = 'ontouchstart' in window && navigator.maxTouchPoints > 0;
    const hasReachedMinimum = Boolean(header.querySelector('overflow-list')?.hasAttribute('minimum-reached'));
    const next = isTouchDevice || hasReachedMinimum ? 'drawer' : 'menu';
    if (header.dataset.menuStyle !== next) header.dataset.menuStyle = next;
  };

  const connectLayoutObservers = () => {
    const nextHeader = document.querySelector('header-component');
    const nextGroup = document.querySelector('#header-group');
    if (!nextHeader || !nextGroup) return;
    const changed = nextHeader !== headerElement || nextGroup !== headerGroup;
    headerElement = nextHeader;
    headerGroup = nextGroup;

    if (changed && 'ResizeObserver' in window) {
      resizeObserver?.disconnect();
      resizeObserver = new ResizeObserver(() => {
        scheduleMeasurement();
        updateMenuStyle();
      });
      resizeObserver.observe(headerElement);
      resizeObserver.observe(headerGroup);
    }
    scheduleMeasurement();
    updateMenuStyle();
  };

  const EMPTY_SKU = '__ib_no_sku__';
  const NORMALIZE_SELECTOR = [
    'a[target="_blank"]',
    'header a[href="#"]',
    '.header a[href="#"]',
    `product-card[data-product-sku="${EMPTY_SKU}"]`,
    `.product-card[data-product-sku="${EMPTY_SKU}"]`
  ].join(',');

  const needsNormalization = (root) => root instanceof Element && (
    root.matches(NORMALIZE_SELECTOR) || Boolean(root.querySelector(NORMALIZE_SELECTOR))
  );

  const normalizeAddedContent = (root = document) => {
    const links = [];
    if (root instanceof Element && root.matches('a[target="_blank"]')) links.push(root);
    root.querySelectorAll?.('a[target="_blank"]').forEach((link) => links.push(link));
    links.forEach((link) => {
      const tokens = new Set((link.getAttribute('rel') || '').split(/\s+/).filter(Boolean));
      tokens.add('noopener');
      tokens.add('noreferrer');
      link.setAttribute('rel', [...tokens].join(' '));
    });

    const menuLinks = [];
    if (root instanceof Element && root.matches('header a[href="#"], .header a[href="#"]')) menuLinks.push(root);
    root.querySelectorAll?.('header a[href="#"], .header a[href="#"]').forEach((link) => menuLinks.push(link));
    menuLinks.forEach((link) => {
      const top = link.matches('.menu-list__link[aria-haspopup="true"]');
      const nested = link.matches('.mega-menu__link--parent') && Boolean(link.parentElement?.querySelector('ul'));
      if (top || nested) link.dataset.ibMenuHeading = 'true';
    });

    root.querySelectorAll?.(
      `product-card[data-product-sku="${EMPTY_SKU}"] .ib-card-sku,` +
      `.product-card[data-product-sku="${EMPTY_SKU}"] .ib-card-sku`
    ).forEach((line) => {
      line.hidden = true;
      line.setAttribute('aria-hidden', 'true');
    });
  };

  const start = () => {
    if (!document.head.querySelector('[data-ib-search-card-integrity]')) {
      const style = document.createElement('style');
      style.dataset.ibSearchCardIntegrity = 'true';
      style.textContent =
        `product-card[data-product-sku="${EMPTY_SKU}"] .ib-card-sku,` +
        `.product-card[data-product-sku="${EMPTY_SKU}"] .ib-card-sku{display:none!important}`;
      document.head.append(style);
    }

    connectLayoutObservers();
    normalizeAddedContent();

    document.addEventListener('click', (event) => {
      const heading = event.target instanceof Element
        ? event.target.closest('[data-ib-menu-heading="true"]')
        : null;
      if (heading) event.preventDefault();
    });

    if ('MutationObserver' in window && document.body) {
      new MutationObserver((mutations) => {
        for (const mutation of mutations) {
          for (const node of mutation.addedNodes) {
            if (needsNormalization(node)) normalizeAddedContent(node);
          }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();

  window.addEventListener('orientationchange', connectLayoutObservers, { passive: true });
  document.addEventListener('shopify:section:load', (event) => {
    connectLayoutObservers();
    normalizeAddedContent(event.target);
  });
  document.fonts?.ready?.then(scheduleMeasurement);
})();
